(() => {
  const cardSelector = '.collection-v2 product-card.card--collection-v2';
  const footerSelector = '.collection-v2-card__footer';
  const mobile = window.matchMedia('(max-width: 767px)');
  const observedCards = new Map();
  let frame = 0;

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(syncRows);
  };

  // Ignore height-only changes caused by stacking the actions ourselves.
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      if (observedCards.get(target) !== contentRect.width) {
        observedCards.set(target, contentRect.width);
        schedule();
      }
    });
  });

  function syncRows() {
    frame = 0;
    const cards = [...document.querySelectorAll(cardSelector)];
    const currentCards = new Set(cards);
    observedCards.forEach((width, card) => {
      if (!currentCards.has(card)) {
        resizeObserver.unobserve(card);
        observedCards.delete(card);
      }
    });

    const entries = cards.map((card) => {
      if (!observedCards.has(card)) {
        observedCards.set(card, null);
        resizeObserver.observe(card);
      }
      const footer = card.querySelector(footerSelector);
      // Measure the natural layout, so rows can return to one line when space permits.
      footer?.removeAttribute('data-stack-actions');
      return { card, footer };
    });
    if (!mobile.matches) return;

    const groups = new Map();
    entries.forEach(({ card, footer }) => {
      if (!footer) return;
      const price = footer.querySelector(':scope > .price, :scope > .campaign-price');
      const button = footer.querySelector(':scope > .collection-v2-card__quick-add');
      if (!price || !button) return;
      const bounds = card.getBoundingClientRect();
      const buttonBounds = button.getBoundingClientRect();
      if (!bounds.width || !bounds.height || !buttonBounds.height) return;

      const grid = card.closest('li')?.parentElement || card.parentElement;
      if (!groups.has(grid)) groups.set(grid, []);
      const rows = groups.get(grid);
      let row = rows.find((candidate) => Math.abs(candidate.top - bounds.top) < 2);
      if (!row) {
        row = { top: bounds.top, footers: [], stacked: false };
        rows.push(row);
      }
      row.footers.push(footer);
      row.stacked ||= buttonBounds.top >= price.getBoundingClientRect().bottom - 1;
    });

    // Write after all measurements; a taller row must not affect grouping later rows.
    groups.forEach((rows) => rows.forEach((row) => {
      if (row.stacked) row.footers.forEach((footer) => footer.setAttribute('data-stack-actions', ''));
    }));
  }

  const containsCards = (node) => node instanceof Element &&
    (node.matches(cardSelector) || node.querySelector(cardSelector));

  const init = () => {
    new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        const element = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        return element?.closest('.collection-v2') ||
          [...mutation.addedNodes, ...mutation.removedNodes].some(containsCards);
      });
      if (relevant) schedule();
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      // Our data-stack-actions attribute is deliberately excluded to avoid feedback loops.
      attributeFilter: ['class', 'style', 'hidden']
    });
    schedule();
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
  };

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('load', (event) => {
    if (event.target instanceof Element && event.target.closest(cardSelector)) schedule();
  }, true);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
